import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const faqs = [
  {
    category: '維修流程',
    items: [
      { q: '維修前需要預約嗎？', a: '不需要強制預約，歡迎直接帶機到店。不過建議事先預約，可縮短等待時間，並確保技師準備好所需零件。' },
      { q: '維修需要多長時間？', a: '常見維修如螢幕更換、電池更換通常 1-3 小時內完成，可當日取件。主板維修或進水搶救等複雜項目可能需要 1-5 個工作天。' },
      { q: '維修期間我需要在場嗎？', a: '不需要。您可以將裝置留在店內，維修完成後我們會主動通知您取件。' },
      { q: '維修前會備份我的資料嗎？', a: '我們在進行維修前會提醒您備份重要資料。一般維修不影響資料，但部分主板維修可能有資料遺失風險，建議提前備份。' },
    ],
  },
  {
    category: '費用與保固',
    items: [
      { q: '如何得知維修費用？', a: '我們採透明報價制度，維修前會提供完整費用說明，您確認後我們才開始維修。不會有任何隱藏費用或未知收費。' },
      { q: '如果維修失敗不收費嗎？', a: '是的，如果維修無法解決問題，我們不收取維修費用。主板維修至中途反悔取消維修，我們將會收取診斷的基本檢測費。' },
      { q: '保固期間維修了什麼？', a: '所有維修項目提供 3 個月保固。若在保固期內發生相同問題，我們提供免費重修服務。因人為損壞造成的新問題不在保固範圍內。' },
      { q: '支援哪些付款方式？', a: '目前僅接受現金及銀行轉帳兩種付款方式，不支援刷卡或行動支付。如需轉帳，我們會於維修完成後提供帳號資訊。' },
    ],
  },
  {
    category: '零件與品質',
    items: [
      { q: '使用的是原廠零件嗎？', a: '我們使用原廠規格同等級零件，品質與原廠零件相同，但價格更優惠。部分特殊機型或高端機型可依客戶需求提供原廠零件。' },
      { q: '維修後螢幕顯示效果會和原本一樣嗎？', a: '我們使用原廠同規格 OLED 面板，顯示效果、色彩準確度、觸控靈敏度與原廠一致。' },
      { q: '電池更換後可以在設定查看健康度嗎？', a: '可以。我們更換的電池可正常顯示電池健康度百分比，初始健康度為 100%。' },
    ],
  },
  {
    category: '特殊情況',
    items: [
      { q: '手機進水了怎麼辦？', a: '手機進水後請立即關機！不要嘗試充電或開機，盡快帶機到店。越早送修，成功救機的機率越高。我們提供免費進水初步評估。' },
      { q: '螢幕全黑但手機還有反應怎麼辦？', a: '這通常是螢幕問題，可能是螢幕損壞或連接線鬆脫。建議帶機到店免費診斷，確認問題再決定是否維修。' },
      { q: '折疊手機可以維修嗎？', a: '可以。我們有能力維修 Samsung Galaxy Z Fold 和 Z Flip 系列。折疊機螢幕維修技術要求較高，費用也相對較貴，建議提前詢問報價。' },
    ],
  },
];

export default function FAQPage() {
  const [openItem, setOpenItem] = useState<string | null>(null);

  const toggle = (key: string) => {
    setOpenItem(openItem === key ? null : key);
  };

  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-32 pb-16 bg-gray-950">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <div className="inline-flex items-center gap-2 text-orange-400 text-sm font-medium mb-4">
              <span className="w-8 h-px bg-orange-400" />
              常見問題
              <span className="w-8 h-px bg-orange-400" />
            </div>
            <h1 className="text-5xl font-bold text-white mb-4">FAQ</h1>
            <p className="text-gray-400 max-w-xl mx-auto">
              整理了客戶最常詢問的問題，希望能解答您的疑惑。如有其他問題，歡迎直接聯絡我們。
            </p>
          </div>
        </section>

        {/* FAQ Content */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-6 space-y-12">
            {faqs.map((group) => (
              <div key={group.category}>
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-1 h-6 bg-orange-500 rounded-full" />
                  <h2 className="text-xl font-bold text-gray-900">{group.category}</h2>
                </div>

                <div className="space-y-3">
                  {group.items.map((item, i) => {
                    const key = `${group.category}-${i}`;
                    const open = openItem === key;
                    return (
                      <div
                        key={key}
                        className="bg-white rounded-2xl border border-gray-100 overflow-hidden"
                      >
                        <button
                          onClick={() => toggle(key)}
                          className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-gray-50 transition-colors"
                        >
                          <span className="font-medium text-gray-900 text-[15px] pr-4">{item.q}</span>
                          <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                            <i className={`ri-${open ? 'subtract' : 'add'}-line text-orange-500 text-lg`} />
                          </div>
                        </button>
                        {open && (
                          <div className="px-6 pb-5">
                            <div className="pt-1 border-t border-gray-50">
                              <p className="text-gray-600 text-sm leading-relaxed pt-4">{item.a}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Still Have Questions */}
        <section className="py-16 bg-white">
          <div className="max-w-2xl mx-auto px-6 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-orange-50 rounded-2xl mx-auto mb-6">
              <i className="ri-customer-service-2-line text-orange-500 text-2xl" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">還有其他問題？</h2>
            <p className="text-gray-500 mb-8">歡迎透過以下方式聯絡我們，我們會盡快回覆您的問題</p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a href="tel:0223456789" className="flex items-center gap-2 px-6 py-3 bg-gray-900 text-white rounded-full font-semibold cursor-pointer hover:bg-gray-800 transition-colors whitespace-nowrap">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line" />
                </div>
                電話諮詢
              </a>
              <a href="/contact" className="flex items-center gap-2 px-6 py-3 border-2 border-gray-900 text-gray-900 rounded-full font-semibold cursor-pointer hover:bg-gray-900 hover:text-white transition-colors whitespace-nowrap">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-message-3-line" />
                </div>
                線上留言
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
